import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { WarningAmber as WarningIcon } from '@mui/icons-material';

interface RangesDeletedConfirmationProps {
  confirmOpen: boolean;
  setConfirmOpen: (open: boolean) => void;
  handleSave: (overrides?: Record<string, any>) => void;
}

export const RangesDeletedConfirmation = ({
  confirmOpen,
  setConfirmOpen,
  handleSave,
}: RangesDeletedConfirmationProps) => {
  const handleConfirm = () => {
    setConfirmOpen(false);
    handleSave({ enabled: false });
  };

  return (
    <Dialog
      open={confirmOpen}
      onClose={() => setConfirmOpen(false)}
      aria-labelledby="confirm-dialog-title"
      PaperProps={{ sx: { borderRadius: 3, p: 1, maxWidth: 600 } }}
    >
      <DialogTitle id="confirm-dialog-title" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, fontWeight: 600 }}>
        <WarningIcon color="primary" />
        Booking Will Be Disabled
      </DialogTitle>
      <DialogContent>
        <DialogContentText variant="body1" color="text.primary">
          Removing all time slots will disable the appointment booking feature. No new appointments can be scheduled until you add time slots again and re-enable booking.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={() => setConfirmOpen(false)} color="inherit" sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          autoFocus
          sx={{ borderRadius: '20px', px: 3, textTransform: 'none' }}
        >
          Go Ahead
        </Button>
      </DialogActions>
    </Dialog>
  );
};